<template>
  <div>
    <el-dialog
    :append-to-body="true"
      :title="status?'查看模块':'编辑模块'"
      :visible.sync="editDialogVisible"
      width="30%"
      :close-on-click-modal='false'
      :before-close="closeEditDialog">
      <el-form label-width="110px" ref="ruleForm"  :rules="rules" :model="form" :disabled="status" :close-on-click-modal="false">
        <el-form-item label="菜单名称" prop="menuName">
          <el-input v-model.trim="form.menuName" autocomplete="off" placeholder="请输入菜单名称"></el-input>
        </el-form-item>
        <el-form-item label="菜单优先级" prop="menuPriority">
          <el-input v-model.trim="form.menuPriority" autocomplete="off" placeholder="请输入菜单优先级"></el-input>
        </el-form-item>
        <el-form-item label="菜单路径" prop="menuUrl" >
          <el-input v-model.trim="form.menuUrl" autocomplete="off"  placeholder="请输入菜单路径" ></el-input>
        </el-form-item>
        <el-form-item label="菜单图标" prop="menuIcon">
          <el-input v-model.trim="form.menuIcon" autocomplete="off" placeholder="请输入菜单图标"></el-input>
        </el-form-item>
        <el-form-item label="父菜单" prop="parentMenuId">
           <el-tree
           :render-after-expand="false"
           v-if="defaultCheckedKeys.length>0"
            ref="tree"
            :data="permissionList"
            show-checkbox
            node-key="menuId"
            :check-strictly="true"
            @check-change="checkChange"
            @node-click="handleNodeClick"
            :default-checked-keys="defaultCheckedKeys"
            :props="defaultProps">
          </el-tree>
          <el-col v-else style="color:red">
            该菜单/页面无父菜单
          </el-col>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
           <el-input v-model="form.remark" autocomplete="off"  placeholder="请输入备注" type="textarea" :rows="5" maxlength="100"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeEditDialog">关 闭</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-if="status===false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { menuForId, editMenu, listOwnerMenu } from '@/api/modelManager'
import { mapGetters } from 'vuex'
import { eventBus } from '@/utils/eventBus'
export default {
  props: {
    editDialogVisible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: null
    },
    status: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const priorityValidator = (rule, value, callback) => {
      const reg = /^[0-9]*$/
      console.log(typeof value)
      if (value.length > 20) {
        callback(new Error('请输入20个字符内的菜单优先级'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入数字优先级！'))
      } else {
        callback()
      }
    }
    return {
      form: {},
      rules: {
        menuName: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
          { max: 20, message: '请输入20个字符内的菜单名称', trigger: 'blur' }
        ],
        menuType: [
          { required: true, message: '请选择菜单类型', trigger: 'change' }
        ],
        menuPriority: [
          { required: true, message: '请输入菜单的优先级', trigger: 'blur' },
          // { max: 20, message: '请输入20个字符内的菜单优先级', trigger: 'blur' }
          { validator: priorityValidator, trigger: 'blur' }
        ],
        menuIcon: [
          { max: 20, message: '请输入20个字符内的菜单图标', trigger: 'blur' }
        ],
        menuUrl: [
          { required: true, message: '请输入菜单路径', trigger: 'change' },
          { max: 40, message: '请输入40个字符内的菜单路径', trigger: 'blur' }
        ]
      },
      permissionList: [],
      // 树形控件
      defaultProps: {
        children: 'childMenus',
        label: 'menuName'
      },
      defaultCheckedKeys: [],
      checkedId: '',
      // 权限展示
      accessIds: [],
      charactorOptions: []
    }
  },
  created () {
    console.log(this.status)
    /* console.log('this.editData', this.editData)
    this.form = Object.assign({}, this.editData) */
    this.getMenuForId()
    if (this.getCacheListOwnerMenu) {
      this.permissionList = JSON.parse(this.getCacheListOwnerMenu)
    } else {
      this.getMenuList()
    }
  },
  mounted () {

  },
  computed: {
    ...mapGetters(['getCacheListOwnerMenu'])
  },
  methods: {
    getMenuList () {
      listOwnerMenu().then(res => {
        if (res.data.code === 200 || res.data.code === 0) {
          this.permissionList = res.data.data
        }
      })
    },
    // 属性数据处理
    handleNodeClick (data) {
    },
    // 现在只是做父级上的互斥
    checkChange (data, checked, indeterminate) {
      console.log(data, checked, indeterminate)
      if (checked) {
        this.$refs.tree.setCheckedKeys([data.menuId])
        this.form.parentMenuId = data.menuId
      }
      // const indexs = this.selectOrg.orgsid.indexOf(data.id)
    },
    getMenuForId () {
      menuForId(this.editData.menuId).then((res) => {
        const resData = res.data.data
        console.log(resData.parentMenuId)
        console.log(resData)
        if (resData.parentMenuId !== 0) this.defaultCheckedKeys.push(resData.parentMenuId)
        if (resData.menuUrl === '' || JSON.stringify(resData.menuUrl) === 'null') resData.menuUrl = '---'
        if (resData.menuIcon === '' || JSON.stringify(resData.menuIcon) === 'null') resData.menuIcon = '---'
        this.form = Object.assign({}, resData)
      })
    },
    closeEditDialog () {
      this.$emit('closeEditDialog')
    },
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        console.log(this.form)
        if (valid) {
          const params = Object.assign({}, this.form)
          editMenu(params).then((res) => {
            console.log(res)
            if (res.data.code === 200 || res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '更新成功'
              })
              this.$emit('closeEditDialog', 1)
              eventBus.$emit('updataMentList')// 更新左侧菜单
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>

</style>
